import { ResponsivePictureLayout } from '@news-mono/component-library'
import { layout } from '../../../App.routing'
import { billboardLeaderboardMrec } from '../../ad-units'
import { subscriberExclusive } from '../../home/subscriber-exclusive'
import { GetMainSectionFn, TopicSectionBuilder } from '../custom-topic-routes'

const heroSegment = layout.component({
    type: 'sierra',
    props: {
        verticalSpacing: 'gridGap',
        fixedRatios: ['16:9'],
        heroImageLayout: ResponsivePictureLayout.ObjectFitContain,
        cardOrientation: {
            type: 'Landscape-Portrait',
            maxBreakpoint: 'md',
        },

        cardLayout: ['hero', 'commonWithBackground'],
        dataDefinitionArgs: {
            type: 'curation',
            name: 'countryman',
            offset: 0,
            pageSize: 2,
        },
    },
})

const subheroSegment = layout.component({
    type: 'uniform',
    props: {
        section: 'default',
        verticalSpacing: 'xl',
        cardOrientation: { type: 'Landscape-Portrait' },
        cardLayout: [
            { type: 'november', listLength: 5 },
            ['teaserWithBackground'],
            ['xsImage-mdNoImage-withBG', 'xsImage-mdNoImage-withBG'],
            ['xsImage-mdNoImage-withBG', 'xsImage-mdNoImage-withBG'],
        ],

        dataDefinitionArgs: {
            type: 'curation',
            name: 'countryman',
            offset: 2,
            pageSize: 10,
        },
    },
})

const revChronSegment = layout.component({
    type: 'lima',
    props: {
        verticalSpacing: 'xl',
        fontScale: 1.2,
        fixedRatios: ['16:9'],
        hasBackground: true,
        teaserMode: 'hidden',
        initialColumns: 1,
        intermediateColumns: 2,
        finalColumns: 4,
        cardOrientation: { type: 'Landscape-Portrait' },

        cardLayout: [
            ['teaserWithBackground'],
            [
                {
                    type: 'landscape',
                    format: 'landscape-smTeaser-mdNoTeaser',
                },
                {
                    type: 'landscape',
                    format: 'landscape-smTeaser-mdNoTeaser',
                },
                {
                    type: 'landscape',
                    format: 'landscape-smTeaser-mdNoTeaser',
                },
            ],
            ['teaserWithBackground'],
            ['teaserWithBackground'],
        ],
        dataDefinitionArgs: {
            type: 'listing',
            topics: ['countryman'],
            includeSubTopics: false,
            paging: {
                page: 1,
                pageSize: 6,
            },
        },
    },
})

export const getCountrymanCuratedSection: TopicSectionBuilder['getCuratedSection'] =
    () => {
        return [
            heroSegment,
            subheroSegment,
            ...billboardLeaderboardMrec('one'),
            revChronSegment,
        ]
    }

export const getCountrymanRouteInfo: GetMainSectionFn = (sectionBuilder) => {
    return [
        ...sectionBuilder.getCuratedSection(),
        subscriberExclusive(true),
        layout.component({
            type: 'lima',
            props: {
                verticalSpacing: 'xl',
                fontScale: 1.2,
                fixedRatios: ['16:9'],
                hasBackground: true,
                teaserMode: 'hidden',
                initialColumns: 1,
                intermediateColumns: 2,
                finalColumns: 4,
                cardOrientation: { type: 'Landscape-Portrait' },
                sectionHeader: {
                    heading: 'News',
                    headingUrl: '/countryman/news',
                    section: 'generic',
                },
                dataDefinitionArgs: {
                    type: 'listing',
                    topics: ['countryman/news'],
                    includeSubTopics: false,
                    paging: {
                        page: 1,
                        pageSize: 4,
                    },
                },
            },
        }),
        ...billboardLeaderboardMrec('two'),
        layout.component({
            type: 'lima',
            props: {
                verticalSpacing: 'xl',
                fontScale: 1.2,
                fixedRatios: ['16:9'],
                hasBackground: true,
                teaserMode: 'hidden',
                initialColumns: 1,
                intermediateColumns: 2,
                finalColumns: 4,
                cardOrientation: { type: 'Landscape-Portrait' },
                sectionHeader: {
                    heading: 'Grain',
                    headingUrl: '/countryman/grain',
                    section: 'generic',
                },
                dataDefinitionArgs: {
                    type: 'listing',
                    topics: ['countryman/grain'],
                    includeSubTopics: false,
                    paging: {
                        page: 1,
                        pageSize: 4,
                    },
                },
            },
        }),
        layout.component({
            type: 'lima',
            props: {
                verticalSpacing: 'xl',
                fontScale: 1.2,
                fixedRatios: ['16:9'],
                hasBackground: true,
                teaserMode: 'hidden',
                initialColumns: 1,
                intermediateColumns: 2,
                finalColumns: 4,
                cardOrientation: { type: 'Landscape-Portrait' },
                sectionHeader: {
                    heading: 'Livestock',
                    headingUrl: '/countryman/livestock',
                    section: 'generic',
                },
                dataDefinitionArgs: {
                    type: 'listing',
                    topics: ['countryman/livestock'],
                    includeSubTopics: false,
                    paging: {
                        page: 1,
                        pageSize: 4,
                    },
                },
            },
        }),
        ...billboardLeaderboardMrec('three'),
        layout.component({
            type: 'lima',
            props: {
                verticalSpacing: 'xl',
                fontScale: 1.2,
                fixedRatios: ['16:9'],
                hasBackground: true,
                teaserMode: 'hidden',
                initialColumns: 1,
                intermediateColumns: 2,
                finalColumns: 4,
                cardOrientation: { type: 'Landscape-Portrait' },
                sectionHeader: {
                    heading: 'Wool',
                    headingUrl: '/countryman/wool',
                    section: 'generic',
                },
                dataDefinitionArgs: {
                    type: 'listing',
                    topics: ['countryman/wool'],
                    includeSubTopics: false,
                    paging: {
                        page: 1,
                        pageSize: 4,
                    },
                },
            },
        }),
        layout.component({
            type: 'lima',
            props: {
                verticalSpacing: 'xl',
                fontScale: 1.2,
                fixedRatios: ['16:9'],
                hasBackground: true,
                teaserMode: 'hidden',
                initialColumns: 1,
                intermediateColumns: 2,
                finalColumns: 4,
                cardOrientation: { type: 'Landscape-Portrait' },
                sectionHeader: {
                    heading: 'Politics',
                    headingUrl: '/countryman/politics',
                    section: 'generic',
                },
                dataDefinitionArgs: {
                    type: 'listing',
                    topics: ['countryman/politics'],
                    includeSubTopics: false,
                    paging: {
                        page: 1,
                        pageSize: 4,
                    },
                },
            },
        }),
        layout.component({
            type: 'lima',
            props: {
                verticalSpacing: 'xl',
                fontScale: 1.2,
                fixedRatios: ['16:9'],
                hasBackground: true,
                teaserMode: 'hidden',
                initialColumns: 1,
                intermediateColumns: 2,
                finalColumns: 4,
                cardOrientation: { type: 'Landscape-Portrait' },
                sectionHeader: {
                    heading: 'Machinery',
                    headingUrl: '/countryman/machinery',
                    section: 'generic',
                },
                dataDefinitionArgs: {
                    type: 'listing',
                    topics: ['countryman/machinery'],
                    includeSubTopics: false,
                    paging: {
                        page: 1,
                        pageSize: 4,
                    },
                },
            },
        }),
        layout.component({
            type: 'lima',
            props: {
                verticalSpacing: 'xl',
                fontScale: 1.2,
                fixedRatios: ['16:9'],
                hasBackground: true,
                teaserMode: 'hidden',
                initialColumns: 1,
                intermediateColumns: 2,
                finalColumns: 4,
                cardOrientation: { type: 'Landscape-Portrait' },
                sectionHeader: {
                    heading: 'Field Days',
                    headingUrl: '/countryman/field-days',
                    section: 'generic',
                },
                dataDefinitionArgs: {
                    type: 'listing',
                    topics: ['countryman/field-days'],
                    includeSubTopics: false,
                    paging: {
                        page: 1,
                        pageSize: 4,
                    },
                },
            },
        }),
        ...billboardLeaderboardMrec('four'),
        layout.component({
            type: 'lima',
            props: {
                verticalSpacing: 'xl',
                fontScale: 1.2,
                fixedRatios: ['16:9'],
                hasBackground: true,
                teaserMode: 'hidden',
                initialColumns: 1,
                intermediateColumns: 2,
                finalColumns: 4,
                cardOrientation: { type: 'Landscape-Portrait' },
                sectionHeader: {
                    heading: 'Horticulture',
                    headingUrl: '/countryman/horticulture',
                    section: 'generic',
                },
                dataDefinitionArgs: {
                    type: 'listing',
                    topics: ['countryman/horticulture'],
                    includeSubTopics: false,
                    paging: {
                        page: 1,
                        pageSize: 4,
                    },
                },
            },
        }),
        layout.component({
            type: 'lima',
            props: {
                verticalSpacing: 'xl',
                fontScale: 1.2,
                fixedRatios: ['16:9'],
                hasBackground: true,
                teaserMode: 'hidden',
                initialColumns: 1,
                intermediateColumns: 2,
                finalColumns: 4,
                cardOrientation: { type: 'Landscape-Portrait' },
                sectionHeader: {
                    heading: 'Finance & Markets',
                    headingUrl: '/countryman/finance-markets',
                    section: 'generic',
                },
                dataDefinitionArgs: {
                    type: 'listing',
                    topics: ['countryman/finance-markets'],
                    includeSubTopics: false,
                    paging: {
                        page: 1,
                        pageSize: 4,
                    },
                },
            },
        }),
        layout.component({
            type: 'lima',
            props: {
                verticalSpacing: 'xl',
                fontScale: 1.2,
                fixedRatios: ['16:9'],
                hasBackground: true,
                teaserMode: 'hidden',
                initialColumns: 1,
                intermediateColumns: 2,
                finalColumns: 4,
                cardOrientation: { type: 'Landscape-Portrait' },
                sectionHeader: {
                    heading: 'Opinion',
                    headingUrl: '/countryman/opinion',
                    section: 'generic',
                },
                dataDefinitionArgs: {
                    type: 'listing',
                    topics: ['countryman/opinion'],
                    includeSubTopics: false,
                    paging: {
                        page: 1,
                        pageSize: 4,
                    },
                },
            },
        }),
        layout.component({
            type: 'lima',
            props: {
                verticalSpacing: 'xl',
                fontScale: 1.2,
                fixedRatios: ['16:9'],
                hasBackground: true,
                teaserMode: 'hidden',
                initialColumns: 1,
                intermediateColumns: 2,
                finalColumns: 4,
                cardOrientation: { type: 'Landscape-Portrait' },
                sectionHeader: {
                    heading: 'Country Communities',
                    headingUrl: '/countryman/country-communities',
                    section: 'generic',
                },
                dataDefinitionArgs: {
                    type: 'listing',
                    topics: ['countryman/country-communities'],
                    includeSubTopics: false,
                    paging: {
                        page: 1,
                        pageSize: 4,
                    },
                },
            },
        }),
        layout.component({
            type: 'taboola',
            feature: 'taboola-regionals',
            props: {
                taboolaContainerId: 'taboola-below-home-thumbnails',
                locationType: 'home',
            },
        }),
    ]
}
